import type { SxProps, Theme } from '@mui/material'
import { MolsonButton } from '../molson-button'
import { MolsonIcon } from '../molson-icons'

export type QuantityButtonProps = {
  displayType: 'icon' | 'text'
  isDisabled?: boolean
  onClick: () => void
  type: 'increase' | 'decrease'
  sx?: SxProps<Theme>
  btnSize?: 'small' | 'regular'
}

export const MolsonQuantityButton = ({
  displayType,
  isDisabled,
  onClick,
  type,
  btnSize = 'regular',
  sx
}: QuantityButtonProps) => {
  if (displayType === 'icon') {
    const iconVariant = type === 'decrease' ? 'ARROW_DOWNWARD' : 'ARROW_UPWARD'
    return (
      <MolsonButton
        disabled={isDisabled}
        onClick={onClick}
        startIcon={<MolsonIcon variant={iconVariant} />}
        sx={{
          borderRadius: 1,
          height: 33,
          minWidth: 0,
          p: 1,
          ...sx
        }}
        variant="contained"
      />
    )
  }
  return (
    <MolsonButton
      color="secondary"
      disabled={isDisabled}
      onClick={onClick}
      variant="outlined"
      sx={
        btnSize === 'small'
          ? {
              width: 20,
              minWidth: 20,
              height: 35
            }
          : {
              ...sx
            }
      }
    >
      {type === 'decrease' ? '-' : '+'}
    </MolsonButton>
  )
}
